var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueFeedback,{attrs:{"type":"error"}},[_c('template',{slot:"feedback-title"},[_vm._v("Hoppá! A pályázat beküldése sikertelen!")]),_vm._v(" "),_c('template',{slot:"feedback-action"},[_c('button',{staticClass:"sf-btn",on:{"click":function($event){return _setup.emit('retry')}}},[_vm._v("Megpróbálom újra")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }